import {Theme} from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

const useCallReceiverStyles = makeStyles((theme: Theme) => {
  const {palette: {secondary}} = theme;

  return {
    callDialer: {
      zIndex: 2,
      userSelect: "none",
      background: secondary.main,
      color: secondary.contrastText,
      borderRadius: "50%",
      position: "fixed",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      filter: "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.25))",
      cursor: "pointer",
      padding: "0px 20px",
      "@media (max-width: 768px)": {
        left: "8px",
        bottom: "16px",
        width: "40px",
        height: "40px",
        background: "linear-gradient(-135deg,#263238,#0f559c)",
        padding: "0px 8px",
      },
      "@media (min-width: 768px)": {
        // transform: "translateX(100%)",
        // right: "calc((100vw - var(--container-width)) / 2 - 24px)",
        bottom: "0px",
        // width: "56px",
        background: "linear-gradient(-135deg,#263238,#0f559c)",
        height: "56px",
        borderRadius: "0px",
        width: "375px",
        right: "0px",
      },
    },
    fabIcon: {

    },
    callType: {
      fontSize: "14px",
      display: "flex",
      alignItems: "end",
      "& .material-icons": {
        fontSize: "18px",
        marginRight: "8px",
      },
    },
    eventStatus: {
      fontSize: "14px",
    },
    floatingPanel: {
      borderRadius: "6px 6px 0 0",
      position: "fixed",
      maxHeight: "500px",
      zIndex: "1",
      // padding: "0 16px",
      background: "#1f1f1f",
      boxShadow: "0px 1px 4px rgba(200, 200, 200, 0.5)",
      border: "2px solid rgba(200, 200, 200, 0.5)",
      color: "rgba(255,255,255,0.9)",
      display: "grid",
      gridTemplate: "auto/1fr",
      alignContent: "flex-start",
      gap: "16px",
      overflow: "auto",
      "@media (max-width: 768px)": {
        left: "50%",
        // width: "100%",
        bottom: "60px",
        transform: "translateX(-50%)",
        width: "calc(100vw - 32px)",
      },
      "@media (min-width: 768px)": {
        // right: "calc((100vw - var(--container-width)) / 2)",
        // bottom: "64px",
        // background: "linear-gradient(-135deg,#263238,teal)",
        background: "white",
        right: "0px",
        width: "375px",
        height: "500px",
        bottom: "54px",
      },
      "&[data-open='false']": {
        display: "none",
      },
    },
    iframe: {
      border: "none",
      overflowX: "hidden",
    },
    phoneNo: {
      fontWeight: 500,
      color: "white",
      "@media (max-width: 768px)": {
        fontSize: "20px",
      },
      "@media (min-width: 768px)": {
        fontSize: "20px",
      },
    },
    incomingCall: {
      textAlign: "left",
      padding: "16px 0",
      lineHeight: "30px",
      whiteSpace: "pre-wrap",
      borderBottom: "2px solid rgba(255,255,255,0.9)",
    },
    ongoingCall: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      lineHeight: "30px",
      whiteSpace: "pre-wrap",
      padding: "16px 0",
      position: "sticky",
      top: "0",
      background: "#1f1f1f",
      borderBottom: "2px solid rgba(255,255,255,0.9)",
      zIndex: 1,
    },
    callDuration: {
      fontSize: "14px",
      fontWeight: "normal",
    },
    enquiryTrip: {
      paddingBottom: "16px",
      borderBottom: "1px solid rgba(255,255,255,0.5)",
    },
    transfer: {
      background: "white",
    },
    transferContainer: {
      display: "grid",
      gridTemplate: "auto/1fr auto",
      gap: "16px",
      padding: "16px 0",
      marginBottom: "-16px",
      position: "sticky",
      bottom: "88px",
      background: "#1f1f1f",
    },
    actions: {
      display: "grid",
      gridTemplate: "auto/auto",
      gridAutoFlow: "column",
      gap: "32px",
      alignContent: "center",
      justifyContent: "center",
      padding: "16px 0",
      position: "sticky",
      bottom: "0",
      background: "#1f1f1f",
      minHeight: "88px",
    },
    cta: {
      cursor: "pointer",
      borderRadius: "50%",
      border: "2px solid white",
      background: "rgba(255, 255, 255, 0.1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "@media (max-width: 768px)": {
        width: "40px",
        height: "40px",
      },
      "@media (min-width: 768px)": {
        width: "56px",
        height: "56px",
      },
      "&[data-action='positive']": {
        color: "#009688",
        borderColor: "#009688",
        background: "#e0f2f1",
      },
      "&[data-action='negative']": {
        color: "#b71c1c",
        borderColor: "#b71c1c",
        background: "#ffcdd2",
      },
    },
    newTrip: {
      display: "grid",
      gridTemplate: "auto/1fr auto",
      gap: "4px",
      fontWeight: 500,
      fontSize: "16px",
      color: "white",
    },
    newTripAction: {
      gridRow: "span 4",
      alignSelf: "center",
    },
    customerTag: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#ffffff29",
      color: "#FFFFFF",
      fontSize: "12px",
      height: "30px",
      borderRadius: "4px",
      padding: "8px",
      "@media (min-width: 768px)": {
        margin: "0 8px",
      },
    },
    repeatTag: {
      background: "#ff868629",
    },
    referTag: {
      background: "#00968829",
    },
    newTag: {
      background: "#6587ff29",
    },
    customerTagsContainer: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    agentStatus: {
      fontSize: "14px",
      display: "flex",
      alignItems: "end",
      "& .material-icons": {
        fontSize: "18px",
        marginRight: "8px",
      },
    },
  };
});

export default useCallReceiverStyles;
